import React, { useState } from 'react';
import { Modal, Button, Input, message } from 'antd';
import {
  ModalBody,
  InputLabel,
  Container,
  InputContainer,
  WarningLabel,
  AdduserSec,
  InputRow,
} from './styles';
import { updateLdapConfigs } from '../../utils/services/ldapAPI';
import { withTranslation } from 'react-i18next';
import { LDAP_CONFIGURATION_MODAL as trans } from './translationValues';

const NAMESPACES = ['LDAP_CONFIGURATION_MODAL'];

const LDAPConfigModal = props => {
  const { visible, onCancel, ldapDetails, t } = props;
  const [isLoading, setLoading] = useState(false);
  const [warningText, setWarningText] = useState({
    url: '',
    port: '',
    docStudioDcStr: '',
    usernameIdentifier: '',
    displayName: '',
    userObjectClass: '',
    username: '',
    password: '',
  });
  const {
    ldapUrl,
    ldapPort,
    ldapDocStudioDcStr,
    ldapUsernameIdentifier,
    ldapUserDisplaynameAttr,
    ldapUserObjectClass,
    ldapUsername,
    ldapPassword,
    ldapConfigured,
  } = ldapDetails;
  const [ldapConfigData, setLdapConfigData] = useState({
    ldapUrl,
    ldapPort,
    ldapDocStudioDcStr,
    ldapUsernameIdentifier,
    ldapUserDisplaynameAttr,
    ldapUserObjectClass,
    ldapUsername,
    ldapPassword,
    ldapConfigured,
  });

  const handleKeyPress = e => {
    if (e.key === 'Enter') {
      validateDetails();
    }
  };

  const validateDetails = async () => {
    if (
      ldapConfigData.ldapUrl &&
      ldapConfigData.ldapPort &&
      ldapConfigData.ldapDocStudioDcStr &&
      ldapConfigData.ldapUsernameIdentifier &&
      ldapConfigData.ldapUserDisplaynameAttr &&
      ldapConfigData.ldapUserObjectClass &&
      ldapConfigData.ldapUsername &&
      ldapConfigData.ldapPassword
    ) {
      setLoading(true);
      let ldapresponse = await updateLdapConfigs(ldapConfigData);
      if (ldapresponse && ldapresponse.statusCode === 119) {
        message.success(t(trans.LDAP_UPDATED_SUCCESS_MESSAGE.key, trans.LDAP_UPDATED_SUCCESS_MESSAGE.value))
        const ldapInfo = { ...ldapConfigData };
        ldapInfo.ldapConfigured = true;
        onCancel(ldapInfo);
      } else {
        message.error(t(trans.LDAP_UPDATED_FAILURE_MESSAGE.key, trans.LDAP_UPDATED_FAILURE_MESSAGE.value));
      }
      setLoading(false);
    } else {
      setWarningText({
        url: !ldapConfigData.ldapUrl ? t(trans.EMPTY_URL_ERROR.key, trans.EMPTY_URL_ERROR.value) : '',
        port: !ldapConfigData.ldapPort ? t(trans.EMPTY_PORT_ERROR.key, trans.EMPTY_PORT_ERROR.value) : '',
        docStudioDcStr: !ldapConfigData.ldapDocStudioDcStr ? t(trans.EMPTY_BASE_DN_ERROR.key, trans.EMPTY_BASE_DN_ERROR.value) : '',
        usernameIdentifier: !ldapConfigData.ldapUsernameIdentifier
          ? t(trans.EMPTY_USERNAME_IDENTIFIER_ERROR.key, trans.EMPTY_USERNAME_IDENTIFIER_ERROR.value)
          : '',
        displayName: !ldapConfigData.ldapUserDisplaynameAttr
          ? t(trans.EMPTY_USER_DISPLAY_NAME_ATTR_ERROR.key, trans.EMPTY_USER_DISPLAY_NAME_ATTR_ERROR.value)
          : '',
        userObjectClass: !ldapConfigData.ldapUserObjectClass
          ? t(trans.EMPTY_USER_OBJECT_CLASS_ERROR.key, trans.EMPTY_USER_OBJECT_CLASS_ERROR.value)
          : '',
        username: !ldapConfigData.ldapUsername ? t(trans.EMPTY_USERNAME_ERROR.key, trans.EMPTY_USERNAME_ERROR.value) : '',
        password: !ldapConfigData.ldapPassword ? t(trans.EMPTY_PASSWORD_ERROR.key, trans.EMPTY_PASSWORD_ERROR.value) : '',
      });
    }
  };
  return (
    <Container onKeyDown={e => e.stopPropagation()} onKeyPress={handleKeyPress}>
      <Modal
        title={t(trans.LDAP_CONFIGURATION_TITLE.key, trans.LDAP_CONFIGURATION_TITLE.value)}
        visible={visible}
        width={1000}
        onCancel={() => onCancel(ldapConfigData)}
        maskClosable={false}
        centered
        className="attachment_modal"
        footer={[
          <Button type="primary" loading={isLoading} onClick={() => validateDetails()}>
            {isLoading ? t(trans.UPDATING_BUTTON.key, trans.UPDATING_BUTTON.value) : t(trans.UPDATE_BUTTON.key, trans.UPDATE_BUTTON.value)}
          </Button>,
        ]}
      >
        <ModalBody>
          <AdduserSec style={{ width: '100%' }}>
            <InputRow>
              <InputContainer className="full-width" user={1}>
                <InputLabel>{t(trans.URL_LABEL.key, trans.URL_LABEL.value)}</InputLabel>
                <Input
                  size="large"
                  placeholder={t(trans.URL_PLACEHOLDER.key, trans.URL_PLACEHOLDER.value)}
                  name="url"
                  value={ldapConfigData.ldapUrl}
                  onChange={e => setLdapConfigData({ ...ldapConfigData, ldapUrl: e.target.value })}
                  autoComplete={'off'}
                />
                <WarningLabel>{!ldapConfigData.ldapUrl && warningText.url}</WarningLabel>
              </InputContainer>
              <InputContainer className="full-width" user={1}>
                <InputLabel>{t(trans.PORT_LABEL.key, trans.PORT_LABEL.value)}</InputLabel>
                <Input
                  size="large"
                  placeholder={t(trans.PORT_PLACEHOLDER.key, trans.PORT_PLACEHOLDER.value)}
                  name="port"
                  value={ldapConfigData.ldapPort}
                  onChange={e => setLdapConfigData({ ...ldapConfigData, ldapPort: e.target.value })}
                  autoComplete={'off'}
                />
                <WarningLabel>{!ldapConfigData.ldapPort && warningText.port}</WarningLabel>
              </InputContainer>
            </InputRow>
            <InputRow>
              <InputContainer className="full-width" user={1}>
                <InputLabel>{t(trans.BASE_DN_LABEL.key, trans.BASE_DN_LABEL.value)}</InputLabel>
                <Input
                  size="large"
                  placeholder={t(trans.BASE_DN_PLACEHOLDER.key, trans.BASE_DN_PLACEHOLDER.value)}
                  name="baseDN"
                  value={ldapConfigData.ldapDocStudioDcStr}
                  onChange={e =>
                    setLdapConfigData({ ...ldapConfigData, ldapDocStudioDcStr: e.target.value })
                  }
                  autoComplete={'off'}
                />
                <WarningLabel>
                  {!ldapConfigData.ldapDocStudioDcStr && warningText.docStudioDcStr}
                </WarningLabel>
              </InputContainer>
              <InputContainer className="full-width" user={1}>
                <InputLabel>{t(trans.USERNAME_IDENTIFIER_LABEL.key, trans.USERNAME_IDENTIFIER_LABEL.value)}</InputLabel>
                <Input
                  size="large"
                  placeholder={t(trans.USERNAME_IDENTIFIER_PLACEHOLDER.key, trans.USERNAME_IDENTIFIER_PLACEHOLDER.value)}
                  name="userNameIdentifier"
                  value={ldapConfigData.ldapUsernameIdentifier}
                  onChange={e =>
                    setLdapConfigData({ ...ldapConfigData, ldapUsernameIdentifier: e.target.value })
                  }
                  autoComplete={'off'}
                />
                <WarningLabel>
                  {!ldapConfigData.ldapUsernameIdentifier && warningText.usernameIdentifier}
                </WarningLabel>
              </InputContainer>
            </InputRow>
            <InputRow>
              <InputContainer className="full-width" user={1}>
                <InputLabel>{t(trans.USER_DISPLAY_NAME_ATTR_LABEL.key, trans.USER_DISPLAY_NAME_ATTR_LABEL.value)}</InputLabel>
                <Input
                  size="large"
                  placeholder={t(trans.USER_DISPLAY_NAME_ATTR_PLACEHOLDER.key, trans.USER_DISPLAY_NAME_ATTR_PLACEHOLDER.value)}
                  name="DisplayNameAttr"
                  value={ldapConfigData.ldapUserDisplaynameAttr}
                  onChange={e =>
                    setLdapConfigData({
                      ...ldapConfigData,
                      ldapUserDisplaynameAttr: e.target.value,
                    })
                  }
                  autoComplete={'off'}
                />
                <WarningLabel>
                  {!ldapConfigData.ldapUserDisplaynameAttr && warningText.displayName}
                </WarningLabel>
              </InputContainer>
              <InputContainer className="full-width" user={1}>
                <InputLabel>{t(trans.USER_OBJECT_CLASS_LABEL.key, trans.USER_OBJECT_CLASS_LABEL.value)}</InputLabel>
                <Input
                  size="large"
                  placeholder={t(trans.USER_OBJECT_CLASS_PLACEHOLDER.key, trans.USER_OBJECT_CLASS_PLACEHOLDER.value)}
                  name="userObjectClass"
                  value={ldapConfigData.ldapUserObjectClass}
                  onChange={e =>
                    setLdapConfigData({ ...ldapConfigData, ldapUserObjectClass: e.target.value })
                  }
                  autoComplete={'off'}
                />
                <WarningLabel>
                  {!ldapConfigData.ldapUserObjectClass && warningText.userObjectClass}
                </WarningLabel>
              </InputContainer>
            </InputRow>
            <InputRow>
              <InputContainer className="full-width" user={1}>
                <InputLabel>{t(trans.USERNAME_PLACEHOLDER.key, trans.USERNAME_PLACEHOLDER.value)}</InputLabel>
                <Input
                  size="large"
                  placeholder={t(trans.USERNAME_PLACEHOLDER.key, trans.USERNAME_PLACEHOLDER.value)}
                  name="userName"
                  value={ldapConfigData.ldapUsername}
                  onChange={e =>
                    setLdapConfigData({ ...ldapConfigData, ldapUsername: e.target.value })
                  }
                  autoComplete={'off'}
                />
                <WarningLabel>{!ldapConfigData.ldapUsername && warningText.username}</WarningLabel>
              </InputContainer>
              <InputContainer className="full-width" user={1}>
                <InputLabel>{t(trans.PASSWORD_LABEL.key, trans.PASSWORD_LABEL.value)}</InputLabel>
                <Input.Password
                  size="large"
                  placeholder={t(trans.PASSWORD_PLACEHOLDER.key, trans.PASSWORD_PLACEHOLDER.value)}
                  name="password"
                  value={ldapConfigData.ldapPassword}
                  onChange={e =>
                    setLdapConfigData({ ...ldapConfigData, ldapPassword: e.target.value })
                  }
                  autoComplete={'off'}
                />
                <WarningLabel>{!ldapConfigData.ldapPassword && warningText.password}</WarningLabel>
              </InputContainer>
            </InputRow>
          </AdduserSec>
        </ModalBody>
      </Modal>
    </Container>
  );
};

export default withTranslation(NAMESPACES)(LDAPConfigModal);
